import { render, staticRenderFns } from "./InternationalWire.vue?vue&type=template&id=387b045d&scoped=true&"
import script from "./InternationalWire.vue?vue&type=script&lang=js&"
export * from "./InternationalWire.vue?vue&type=script&lang=js&"
import style0 from "./InternationalWire.vue?vue&type=style&index=0&id=387b045d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b045d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387b045d')) {
      api.createRecord('387b045d', component.options)
    } else {
      api.reload('387b045d', component.options)
    }
    module.hot.accept("./InternationalWire.vue?vue&type=template&id=387b045d&scoped=true&", function () {
      api.rerender('387b045d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/accounting/forms/InternationalWire.vue"
export default component.exports